export const ascensionCost = [
    {
        minLvl:1,
        maxLvl:20,
        moraCost:0,
        ascensionMaterialRequired : {
            bossMaterial: 0,
            stone1:0,
            stone2:0,
            stone3:0,
            stone4:0
        }
    },
    {
        minLvl:21,
        maxLvl:40,
        moraCost:20000,
        ascensionMaterialRequired : {
            bossMaterial: 0,
            stone1:1,
            stone2:0,
            stone3:0,
            stone4:0
        }
    },
    {
        minLvl:41,
        maxLvl:50,
        moraCost:60000,
        ascensionMaterialRequired : {
            bossMaterial:2,
            stone1:1,
            stone2:3,
            stone3:0,
            stone4:0
        }
    },
    {
        minLvl:51,
        maxLvl:60,
        moraCost:120000,
        ascensionMaterialRequired : {
            bossMaterial:6,
            stone1:1,
            stone2:9,
            stone3:0,
            stone4:0
        }
    },
    {
        minLvl:61,
        maxLvl:70,
        moraCost:200000,
        ascensionMaterialRequired : {
            bossMaterial:12,
            stone1:1,
            stone2:9,
            stone3:3,
            stone4: 0
        }
    },
    {
        minLvl:71,
        maxLvl:80,
        moraCost:300000,
        ascensionMaterialRequired : {
            bossMaterial:24,
            stone1:1,
            stone2:9,
            stone3:9,
            stone4: 0
        }
    },
    {
        minLvl:81,
        maxLvl:90,
        moraCost:420000,
        ascensionMaterialRequired : {
            bossMaterial:44,
            stone1:1,
            stone2:9,
            stone3:9,
            stone4:6
        }
    },
]